import { render } from "./App.vue?vue&type=template&id=5f8508b6&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=5f8508b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5f8508b6"

export default script